import {
  mapStudentClassificationFromColumn,
  type StudentClassification,
} from '../types';
import type { PerformanceRow } from '../types/performance';
import { requestEdgeFunction } from '../services/edgeFunctionClient';

export async function enrichPerformanceRows(rows: PerformanceRow[]): Promise<PerformanceRow[]> {
  if (rows.length === 0) {
    return rows;
  }

  const studentIds = Array.from(new Set(rows.map((row) => row.student_id)));
  const enrichment = await requestEdgeFunction<{
    success?: boolean;
    data?: {
      classifications?: Array<{ student_id?: number; classification?: string | StudentClassification | null }>;
    };
  }>('students', {
    method: 'POST',
    body: {
      action: 'get-performance-enrichment',
      payload: { studentIds },
    },
  }).catch(() => null);

  const classificationByStudentId = new Map<number, StudentClassification | null>();
  for (const entry of enrichment?.data?.classifications ?? []) {
    const studentId = Number(entry.student_id);
    if (Number.isFinite(studentId) && studentId > 0) {
      classificationByStudentId.set(
        studentId,
        typeof entry.classification === 'string'
          ? mapStudentClassificationFromColumn(entry.classification)
          : (entry.classification ?? null) as StudentClassification | null,
      );
    }
  }

  if (classificationByStudentId.size === 0) {
    return rows;
  }

  return rows.map((row) => (
    row.classification?.status
      ? row
      : {
        ...row,
        classification: classificationByStudentId.get(row.student_id) ?? row.classification,
      }
  ));
}
